import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Form, FormGroup, Label } from 'reactstrap';

const AttendeeDetails = (props) => {
    const [name, setName] = useState(null)
    const [dob, setDob] = useState(null)
    const [validId, setValidId] = useState(null)

    const submitHandler = (e) => {
        e.preventDefault()
        props.addGuest({ name, dob, validId })
        props.toggle()
        setName(null)
        setDob(null)
        setValidId(null)
    }

    return (
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <Form onSubmit={submitHandler}>
                    <ModalHeader toggle={props.toggle}><b>Attendee Details</b></ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Full Name as per ID</Label>
                            <Input
                                type='text'
                                onChange={e => setName(e.target.value)}
                                value={name}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date of Birth</Label>
                            <Input
                                type='date'
                                onChange={e => setDob(e.target.value)}
                                value={dob}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Passport/IC*</Label>
                            <Input
                                type='text'
                                onChange={e => setValidId(e.target.value)}
                                value={validId}
                                required
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type='submit'>Accept</Button>{' '}
                        <Button color="secondary" onClick={props.toggle}>Close</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
}

export default AttendeeDetails;